// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/clipboard-document-check.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/clipboard-document-check'

import { Icon, type IconComponentProps } from '../icon'

export const ClipboardDocumentCheckIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
